module.exports = __webpack_public_path__ + "static/media/Emojione_1F4A9.b4b64574.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Emojione_1F4A9.svg
 ** module id = 177
 ** module chunks = 0
 **/